if (!window.Eurus.loadedScript.has('popup-page-content.js')) {
  window.Eurus.loadedScript.add('popup-page-content.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPagePopup', (data) => ({
        open: false,
        loading: false,
        loaded: false,
        content: '',
        containerId: data.containerId,
        closeId: data.closeId,
        openPopup() {
          this.open = true;
          Alpine.store('xPopup').open = true;

          if (!this.loaded) {
            this.loading = true;
            fetch(data.url)
              .then((response) => response.text())
              .then((html) => {
                const main = new DOMParser().parseFromString(html, 'text/html').getElementById('MainContent');
                this.content = main ? main.innerHTML : '';
                this.loaded = true;
              })
              .finally(() => {
                this.loading = false;
              });
          }

          window.requestAnimationFrame(() => {
            Alpine.store('xModal').focus(this.containerId, this.closeId);
          });
        },
        closePopup() {
          this.open = false;
          Alpine.store('xModal').removeFocus();
          Alpine.store('xPopup').close();
        }
      }));
    });
  });
}
